import { render, staticRenderFns } from "./CascoAjanlatAdatokB15_V0.vue?vue&type=template&id=435ec7a9&"
import script from "./CascoAjanlatAdatokB15_V0.vue?vue&type=script&lang=js&"
export * from "./CascoAjanlatAdatokB15_V0.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports